<style>
@import '../../assets/css/account.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <form @submit.prevent="initialize" :submit="initialize">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <el-input v-model="ajaxSearch.member" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('account_member.table_affiliate_id')}}</template>
                            <el-input v-model="ajaxSearch.affiliate_id" clearable></el-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_date')}}</template>
                            <b-form-input v-model="ajaxSearch.created_at" type="date"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('account_member.table_account_job')}}</template>
                            <b-form-select v-model="ajaxSearch.account_job">
                                <option value="admin">{{$t('admin.table_admin')}}</option>
                                <option value="member">{{$t('admin.table_member')}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label"></template>
                            <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                        </b-form-group>
                    </form>
                </b-card>
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" v-b-modal.exportMember v-if="permissionList.includes(permission.export)"><font-awesome-icon icon="plus"/> {{$t('account_member.table_export_member')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="infoMember()" v-if="permissionList.includes(permission.info)">{{$t('account_member.table_member_info')}}</b-button>
                            <b-button variant="primary" size="lg" @click="getEditMember()" v-if="permissionList.includes(permission.edit)" class="ml-1">{{$t('account_member.table_member_edit')}}</b-button>
                            <b-button variant="success" size="lg" @click="getPermissionMember()" v-if="permissionList.includes(permission.userAcess) && showAdmin" class="ml-1">{{$t('account_member.table_user_access')}}</b-button>    
                            <b-button variant="success" size="lg" @click="logMember()" v-if="permissionList.includes(permission.memberLog)" class="ml-1">{{$t('admin.table_member_log')}}</b-button>
                            <b-button variant="danger" size="lg" @click="resetLocation()" v-if="permissionList.includes(permission.resetLocation)" class="ml-1">{{$t('admin.table_reset_location')}}</b-button>                                                                              
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>

                <b-modal id="infoMember" :title="$t('account_member.table_member_info')" hide-footer size="lg">
                    <b-tabs class="custom-tab">
                        <b-tab active>
                            <template slot="title">
                                <div class="tab-title">
                                    <span>{{$t('account_member.table_step_1')}}</span>
                                    <br/>
                                    <span>{{$t('account_member.table_account_info')}}</span>
                                </div>
                            </template>

                            <b-row class="form-label p-2">
                                <b-col cols="12" class="my-2">
                                    <h4><ins>{{$t('account_member.table_account_info')}}</ins></h4>
                                </b-col>
                                <b-col cols="12" lg="6">
                                    <b-form-group label-cols="4" label-cols-lg="4">
                                        <template slot="label">{{$t('account_member.table_user_id')}}</template>
                                        <label>{{ajaxInfo.login}} <b style="word-wrap: break-word;">[{{ajaxInfo.real_password}}] [{{ajaxInfo.real_security}}] [{{ajaxInfo.real_gesture_security}}]</b></label>
                                    </b-form-group>
                                    <b-form-group label-cols="4" label-cols-lg="4">
                                        <template slot="label">{{$t('account_member.table_affiliate_id')}}</template>
                                        <label>{{ajaxInfo.affiliate_id}}</label>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" lg="6">
                                    <b-form-group label-cols="4" label-cols-lg="4">
                                        <template slot="label">{{$t('account_member.table_account_status')}}</template>
                                        <label>{{ajaxInfo.status}}</label>                                                        
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>

                        <b-tab>
                            <template slot="title">
                                <div class="tab-title">
                                    <span>{{$t('account_member.table_step_2')}}</span>
                                    <br/>
                                    <span>{{$t('account_member.table_personal_info')}}</span>
                                </div>
                            </template>

                            <b-row class="form-label p-2">
                                <b-col cols="12" class="my-2">
                                    <h4><ins>{{$t('account_member.table_personal_info')}}</ins></h4>
                                </b-col>
                                <b-col cols="12" lg="6">
                                    <b-form-group label-cols="4" label-cols-lg="4">
                                        <template slot="label">{{$t('account_member.table_full_name')}}</template>
                                        <label>{{ajaxInfo.name}}</label>
                                    </b-form-group>
                                    <b-form-group label-cols="4" label-cols-lg="4">
                                        <template slot="label">{{$t('account_member.table_email')}}</template>
                                        <label>{{ajaxInfo.email}}</label>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" lg="6">
                                    <b-form-group label-cols="4" label-cols-lg="4">
                                        <template slot="label">{{$t('account_member.table_created_at')}}</template>
                                        <label>{{ajaxInfo.created_at}}</label>                                                        
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-modal>

                <b-modal id="editMember" :title="$t('account_member.table_member_edit')" hide-footer size="lg">
                    <form id="editMemberForm" @submit.prevent="editMember()">
                        <b-tabs class="custom-tab" v-model="tabIndex">
                            <b-tab active>
                                <template slot="title">
                                    <div class="tab-title">
                                        <span>{{$t('account_member.table_step_1')}}</span>
                                        <br/>
                                        <span>{{$t('account_member.table_account_info')}}</span>
                                    </div>
                                </template>

                                <b-row class="form-label p-2">
                                    <b-col cols="12" class="my-2">
                                        <h4><ins>{{$t('account_member.table_account_info')}}</ins></h4>
                                    </b-col>
                                    <b-col cols="12" lg="6">
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('account_member.table_user_id')}}</template>
                                            <b-form-input v-model="ajaxEdit.login" name="login"></b-form-input>
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('account_member.table_account_status')}}</template>
                                            <b-form-select name="status" v-model="ajaxEdit.status">
                                                <option value='normal'>{{$t('account_member.table_normal')}}</option>
                                                <option value='inactive'>{{$t('account_member.table_inactive')}}</option>
                                                <option value='suspended'>{{$t('account_member.table_suspended')}}</option>
                                            </b-form-select>                                                        
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('admin.table_otp')}}</template>
                                            <b-form-select name="otp_code" v-model="ajaxEdit.otp_code">
                                                <option value='-'>-</option>
                                                <option :value='list.code' v-for="(list,index) in ajaxToolList.otp_list" :key="index">{{list.name}}</option>
                                            </b-form-select>                                                        
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('admin.table_trader')}}</template>
                                            <b-form-checkbox name="trader" size="lg" value="1" unchecked-value="0" switch v-model="ajaxEdit.trader"></b-form-checkbox>   
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('admin.table_gesture_lock')}}</template>
                                            <b-form-checkbox name="is_gesture" size="lg" value="1" unchecked-value="0" switch v-model="ajaxEdit.is_gesture" :disabled="ajaxEdit.is_gesture == 0"></b-form-checkbox>   
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('account_member.table_affiliate_id')}}</template>
                                            <label>{{ajaxEdit.affiliate_id}}</label>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" lg="6">
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('admin.table_google_authenticator')}}</template>
                                            <b-form-checkbox name="google_authenticator_switch" size="lg" value="1" unchecked-value="0" switch v-model="ajaxEdit.google_authenticator_switch" :disabled="ajaxEdit.google_authenticator_switch == 0"></b-form-checkbox>   
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('admin.table_mnemonic')}}</template>
                                            <b-form-checkbox name="mnemonic_verify" size="lg" value="1" unchecked-value="0" switch v-model="ajaxEdit.mnemonic_verify" :disabled="ajaxEdit.mnemonic_verify == 0"></b-form-checkbox>   
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('account_member.table_password')}}</template>
                                            <b-form-input name="password" type="password"></b-form-input>
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('account_member.table_confirm_password')}}</template>
                                            <b-form-input name="confirm_password" type="password"></b-form-input>
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('account_member.table_security_password')}}</template>
                                            <b-form-input name="security" type="password"></b-form-input>
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('account_member.table_confirm_security_password')}}</template>
                                            <b-form-input name="confirm_security" type="password"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-button variant="primary" @click="tabIndex++" class="float-right">{{$t('button.table_next')}}</b-button>
                                    </b-col>
                                </b-row>
                            </b-tab>

                            <b-tab>
                                <template slot="title">
                                    <div class="tab-title">
                                        <span>{{$t('account_member.table_step_2')}}</span>
                                        <br/>
                                        <span>{{$t('account_member.table_personal_info')}}</span>
                                    </div>
                                </template>

                                <b-row class="form-label p-2">
                                    <b-col cols="12" class="my-2">
                                        <h4><ins>{{$t('account_member.table_personal_info')}}</ins></h4>
                                    </b-col>
                                    <b-col cols="12" lg="6">
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('account_member.table_full_name')}}</template>
                                            <b-form-input v-model="ajaxEdit.name" name="name"></b-form-input>
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('account_member.table_email')}}</template>
                                            <b-form-input v-model="ajaxEdit.email" name="email"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" lg="6">
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('admin.table_phone_mobile')}}</template>
                                            <b-form-input v-model="ajaxEdit.phone_mobile" name="phone_mobile"></b-form-input>
                                        </b-form-group>
                                        <b-form-group label-cols="4" label-cols-lg="4">
                                            <template slot="label">{{$t('account_member.table_created_at')}}</template>
                                            <label>{{ajaxEdit.created_at}}</label>                                                    
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-button variant="primary" @click="tabIndex--" class="float-left">{{$t('button.table_previous')}}</b-button>
                                        <b-button variant="primary" @click="editMember()" class="float-right">{{$t('button.submit')}}</b-button>
                                    </b-col>
                                </b-row>
                            </b-tab>
                        </b-tabs>
                    </form>
                </b-modal>

                <b-modal id="permissionMember" :title="$t('account_member.table_user_access')" @ok="permissionMember" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')" size="xl">
                    <form id="permissionMemberForm" @submit.prevent="permissionMember">
                        <b-button @click="permissionMember" variant="primary" class="float-right col-12">{{$t('button.submit')}}</b-button>
                        <b-card v-for="(permission,index) in ajaxPermission" :key="index" class="mb-3" style="background: #f1f1f1;">
                            <b-form-group>
                                <b-button variant="info" class="mb-4">
                                    <b-form-checkbox v-model="ajaxPermission[index].valid" value="1" @change="permissionAll(permission.title)" :id="permission.title">{{permission.title}}</b-form-checkbox>
                                </b-button>
                                <b-row class="px-3">
                                    <b-form-checkbox-group class="col-12 col-md-4 p-0" name="code[]" v-for="(content,indexContent) in permission.content" :key="indexContent" v-model="ajaxPermission[index].content[indexContent].valid">
                                        <b-form-checkbox :value="content.code" :id="permission.title + indexContent">{{content.path}}</b-form-checkbox>
                                        <hr class="my-2">
                                    </b-form-checkbox-group>
                                </b-row>
                            </b-form-group>
                        </b-card>
                    </form>
                </b-modal>

                <b-modal id="exportMember" :title="$t('account_member.table_export_member')" @ok="exportMember" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="exportMemberForm" @submit.prevent="permissionMember">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_date')}}</template>
                            <b-form-input type="date" name="date" v-model="ajaxExport"></b-form-input>
                        </b-form-group>
                    </form>
                </b-modal>

                <b-modal id="logMember" :title="$t('admin.table_member_log')" hide-footer size="xl">
                    <el-table class="custom-table" :data="ajaxTableMemberLog" ref="tableTestMemberLog" border>
                        <el-table-column v-for="title in titlesMemberLog" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxToolMemberLog.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChangeMemberLog" @current-change="paginationCurrentChangeMemberLog" :current-page.sync="ajaxToolMemberLog.current_pagination" :total="ajaxToolMemberLog.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {memberAjaxTable,memberInfo,getMemberEdit,memberEdit,getPermissionMember,permissionMember,memberExport,getMemberBadge,badgeMember,locationReset,memberLog} from '@/system/model/account'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';
export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxTableMemberLog:[],
            ajaxToolMemberLog:[],
            ajaxSearch:{limit:'',pagination:'',master_id:'',created_at:'',login:'',affiliate_id:'',trader:'',status:'',old_leader:'',old_leader_id:'',account_job:'',member:''},
            ajaxSearchMemberLog:{limit:'',pagination:''},
            ajaxRow:'',
            ajaxInfo:[],
            ajaxEdit:[],
            ajaxPermission:[],
            ajaxExport:[],
            showAdmin:false,
            tabIndex:1,
            pageLimit:10,
            ajaxToolList:[],
            permission:{
                info:'189733',
                edit:'617900',
                userAcess:'1820CC',
                export:'5139D6',
                resetLocation:'4E90B2',
                memberLog:'89C542'
            },
            isJob:true,
            permissionList:[],
            titles:[{
                prop: "master_id",
                label: this.$t('account_member.table_id'),
                width:'100'
            },{
                prop: "created_at",
                label: this.$t('account_member.table_date'),
                width:'300'
            },{
                prop: "login",
                label: this.$t('account_member.table_username'),
                width:'300'
            },{
                prop: "affiliate_id",
                label: this.$t('account_member.table_affiliate_id'),
                width:'200'       
            },{
                prop: "trader",
                label: this.$t('admin.table_trader'),
                width:'150'                              
            },{
                prop: "old_leader",
                label: this.$t('account_member.table_leader'),
                width:'150'                              
            },{
                prop: "old_leader_id",
                label: this.$t('account_member.table_leader') + ' ID',
                width:'150'                              
            },{
                prop: "status",
                label: this.$t('account_member.table_account_status'),
                width:'150'                              
            }], 
            titlesMemberLog:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'50'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'150'
            },{
                prop: "master_id",
                label: this.$t('admin.table_master_id'),
                width:'80'
            },{
                prop: "remark",
                label: this.$t('admin.table_remark'),
                width:'250'
            },{
                prop: "ip",
                label: this.$t('admin.table_ip_address'),
                width:'160'
            }]       
        }
    },methods:{
        initialize(){
            var self = this;
            var result = memberAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.master_id,this.ajaxSearch.created_at,this.ajaxSearch.login,this.ajaxSearch.affiliate_id,this.ajaxSearch.trader,this.ajaxSearch.old_leader,this.ajaxSearch.old_leader_id,this.ajaxSearch.status,this.ajaxSearch.account_job,this.ajaxSearch.member);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                    if(self.isJob){
                        self.isJob = false;
                        if(self.ajaxTable[0].account_job && !self.permissionList.includes("account_job")){
                            self.titles.push({prop:"account_job",label: self.$t('account_member.table_account_job'),width: '150'})
                        }
                    }
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },infoMember(){
            if(this.permissionList.includes(this.permission.info)){
                var self = this;
                var result = memberInfo(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('infoMember');
                    if(value.valid){
                        self.ajaxInfo = value.data;
                    }
                });
            }
        },getEditMember(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getMemberEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('editMember');
                    if(value.valid){
                        self.ajaxEdit = value.data;
                    }
                });
            }
        },getPermissionMember(){
            if(this.permissionList.includes(this.permission.userAcess)){
                var self = this;
                var result = getPermissionMember(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('permissionMember');
                    if(value.valid){
                        self.ajaxPermission = value.data;
                    }
                });
            }
        },permissionMember(){
            var self = this;
            var form = document.getElementById('permissionMemberForm');
            var formData = new FormData(form);
            formData.append(this.csrfNameKey, this.csrfName); 
            formData.append(this.csrfValueKey, this.csrfValue); 
            formData.append('master_id', this.ajaxRow); 
            var result = permissionMember(formData);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.$swal.fire({
                        type: 'success',
                        text: self.$t(value.returnMsg),
                        onClose: () => {
                            self.initialize();
                            self.$bvModal.hide('permissionMember');
                        }
                    });
                }else{
                    var text = "";
                    if(Array.isArray(value.returnMsg)){
                        value.returnMsg.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                    }else{
                        text = self.$t(value.returnMsg);
                    }

                    self.$swal.fire({
                        type: 'error',
                        html: text,
                        onClose: () => {
                            self.initialize();
                            self.$bvModal.hide('permissionMember');
                        }
                    });
                }
            });
        },permissionAll(checked){
            for(var i = 0;i < this.ajaxPermission.length;i++){
                if(this.ajaxPermission[i].title == checked){
                    if(document.getElementById(checked).checked == true){
                        for(var c = 0;c<this.ajaxPermission[i].content.length;c++){
                            document.getElementById(checked+c).checked = true;
                        }
                    }else{
                        for(var c = 0;c<this.ajaxPermission[i].content.length;c++){
                            document.getElementById(checked+c).checked = false;
                        }
                    }
                }
            }
        },editMember(){
            var self = this;
            var form = document.getElementById('editMemberForm');
            var formData = new FormData(form);
            formData.append(this.csrfNameKey, this.csrfName); 
            formData.append(this.csrfValueKey, this.csrfValue); 
            formData.append('master_id', this.ajaxEdit.master_id); 
            var result = memberEdit(formData);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.$swal.fire({
                        type: 'success',
                        text: self.$t(value.returnMsg,{member:value.member}),
                        onClose: () => {
                            self.initialize();
                            self.$bvModal.hide('editMember');
                        }
                    });
                }else{
                    var text = "";
                    if(Array.isArray(value.returnMsg)){
                        value.returnMsg.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                    }else{
                        text = self.$t(value.returnMsg);
                    }

                    self.$swal.fire({
                        type: 'error',
                        html: text,
                        onClose: () => {
                            self.initialize();
                            self.$bvModal.hide('editMember');
                        }
                    });
                }
            });
        },exportMember(){
            if(this.permissionList.includes(this.permission.export)){
                var self = this;
                var result = memberExport(this.ajaxExport);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        window.open(value.data, "_blank");    
                    }
                });
            }
        },resetLocation(){
            if(this.permissionList.includes(this.permission.resetLocation)){
                this.$swal.fire({
                text: this.$t('msg.comfirm_reset'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('master_id', this.ajaxRow); 
                        var result = locationReset(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },logMember(){
            if(this.permissionList.includes(this.permission.memberLog)){
                var self = this;
                var result = memberLog(this.ajaxRow,this.ajaxSearchMemberLog.limit,this.ajaxSearchMemberLog.pagination);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.ajaxTableMemberLog = value.data.datatable.data;
                        self.ajaxToolMemberLog = value.data.datatable;
                        self.csrfName = value.data.csrf_list.csrf_name;
                        self.csrfValue = value.data.csrf_list.csrf_value;
                        self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                        self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                        self.$bvModal.show('logMember');
                    }
                });
            }
        },getToolList(){
            var self = this;
            var result = this.$general.getToolList();
            result.then(function(value){
                self.ajaxToolList = value.data;
            });
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.master_id
            this.showAdmin = false;
            if(row.account_job == 'admin'){
                this.showAdmin = true;
            }
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        },paginationSizeChangeMemberLog(limit){
            this.ajaxSearchMemberLog.limit = limit;
            this.logMember();
        },paginationCurrentChangeMemberLog(pagination){
            this.ajaxSearchMemberLog.pagination = pagination;
            this.logMember();
        }
    },created(){
        this.preloader(false);
        this.initialize();
        this.getToolList();
    }
}
</script>
